export default "/images/6339e4ae783a5fb15a3a87f5f547c63b.avif";